
const getAlert = (alertProps = {}) => () => {
  const { title, message, buttons } = alertProps

}


export default getAlert
